export class ApiError extends Error {
  code: string | undefined;
  retriable: boolean;
  status: number;

  constructor(message: string, status: number, code?: string, retriable?: boolean) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.retriable = retriable ?? false;
  }
}
